import React from "react";
import { Container, Paper, Typography } from "@mui/material";
import MainStepper from "./evlendirme-basvurusu/MainStepper";

const EvlendirmeBasvurusu = () => {
	return (
		<Container maxWidth="xl" sx={{ py: 3 }}>
			<Typography variant="h5" gutterBottom>
				Nikah Başvurusu
			</Typography>
			<Paper elevation={1} sx={{ p: 3 }}>
				<MainStepper />
			</Paper>
		</Container>
	);
};

export default EvlendirmeBasvurusu;